import { BaseCouponsClient, Coupon } from "@core/types";
import { FortimeCoupon } from "./types";
import { convertFortimeCoupon } from "./converters";

class CouponsClient extends BaseCouponsClient {
  async getCoupon(code: string): Promise<Coupon | null> {
    const response = await this.instance.get<FortimeCoupon[]>("/wp-json/wc/v3/coupons", {
      params: {
        code,
      },
    });

    if (response.data[0]) {
      return convertFortimeCoupon(response.data[0]);
    }

    return null;
  }
}

export default CouponsClient;
